import {
  NgModule
} from '@angular/core';
import {
  LoadingIndicatorComponent
} from './loading-indicator.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  CommonModule
} from '@angular/common';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatProgressBarModule
  ],
  declarations: [
    LoadingIndicatorComponent
  ],
  exports: [
    LoadingIndicatorComponent
  ],
  providers: [
  ],
  entryComponents: [],
})
export class LoadingIndicatorModule {
}
